/* Signature interactions. Two jobs, both progressive:
   1) Shared-element morphs: stamps the clicked product-card image with its
      view-transition-name right before navigation, so exactly one element
      on the old page matches the PDP gallery image on the new page.
   2) Magnetic primary CTAs: gentle pull toward the cursor. Fine pointers
      only; disabled for prefers-reduced-motion. */
(function () {
  // --- 1. Morph namer -------------------------------------------------
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href*="/products/"]');
    if (!link) return;
    var card = link.closest('.card-wrapper');
    if (!card) return;
    var img = card.querySelector('[data-kso-vt]');
    if (img) img.style.viewTransitionName = img.dataset.ksoVt;
  });

  // --- 2. Magnetic CTAs ----------------------------------------------
  if (
    !window.matchMedia('(pointer: fine)').matches ||
    window.matchMedia('(prefers-reduced-motion: reduce)').matches
  ) {
    return;
  }

  var PULL = 6;

  function attach(btn) {
    if (btn.dataset.ksoMagnetic) return;
    btn.dataset.ksoMagnetic = 'true';
    btn.style.willChange = 'transform';

    btn.addEventListener('mousemove', function (e) {
      var r = btn.getBoundingClientRect();
      var x = ((e.clientX - r.left) / r.width - 0.5) * 2 * PULL;
      var y = ((e.clientY - r.top) / r.height - 0.5) * 2 * PULL;
      btn.style.transform = 'translate(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px)';
    });

    btn.addEventListener('mouseleave', function () {
      btn.style.transform = '';
    });
  }

  function scan() {
    document
      .querySelectorAll('.kso-hero .button, .product-form__submit, .kso-sticky-atc .button')
      .forEach(attach);
  }

  scan();
  document.addEventListener('shopify:section:load', scan);
})();
